import type { CanvasNodeCatalogEntry } from '../api'

export const PROVIDER_NODE_QUERY_KEY = 'node'
export const PROVIDER_NODE_STORAGE_KEY = 'vistoera_platform_admin_provider_node_type'

export function resolveProviderNodeType(
  catalog: CanvasNodeCatalogEntry[],
  opts: {
    keepSelection?: boolean
    previous: string | null
    urlNode: string | null
    storedNode: string | null
  },
): string | null {
  const { keepSelection, previous, urlNode, storedNode } = opts
  const exists = (nodeType: string | null | undefined) =>
    Boolean(nodeType && catalog.some((e) => e.node_type === nodeType))

  if (keepSelection && exists(previous)) return previous!
  if (exists(urlNode)) return urlNode!
  if (exists(storedNode)) return storedNode!
  if (exists(previous)) return previous!
  return catalog[0]?.node_type ?? null
}
